import apiClient from '../index'

export const addLocation = (data) => apiClient.post('/location', data)

export const getLocation = (skip, limit) =>
  apiClient.get('/location', {
    params: {
      skip,
      limit,
    },
  })

export const updateLocation = (id, data) => apiClient.patch(`/location/${id}`, { data })
